export default __webpack_public_path__ + "static/media/adrobot_background_en.88b4889c.png";